import React from "react";

type Props = {
  text: string;
  type: "h1" | "p";
  align?: "center" | "left" | "right";
};

const Title = (props: Props) => {
  const { text, type, align = "left" } = props;

  if (type === "h1")
    return (
      <h1
        className={`text-2xl lg:text-[46px] leading-[1.4] pb-1 font-semibold text-[#3b3b3b] relative ${align === "center" ? "text-center" : align === "right" ? "text-right" : "text-left"} before:absolute before:content-[''] before:w-[200px] before:h-[3px] before:bg-[#81B465] before:bottom-0 before:left-0 ${align === "center" ? "before:left-1/2 before:-translate-x-[50%]" : align === "right" ? "before:right-0 before:left-auto" : ""}`}
      >
        {text}
      </h1>
    );
  if (type === "p")
    return (
      <p
        className={`text-sm w-max lg:text-2xl pt-1 text-[#1e1e1e] font-bold ${align === "center" ? "text-center" : align === "right" ? "text-right" : "text-left"} relative before:absolute before:content-[''] before:w-full before:h-[3px] before:bg-[#2F5597] before:-bottom-2 before:left-0 ${align === "center" ? "before:left-1/2 before:-translate-x-[50%] mx-auto" : align === "right" ? "before:right-0 before:left-auto" : ""}`}
      >
        {text}
      </p>
    );

  return <></>;
};

export default Title;
